// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2sgPi","content":"LoadingAlert_content__2Qu9c"};